
var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.CanvasMapFeature = new Class({
    init_canvas_draw: function () {
        this.addEvent('layer_group_added', this.on_canvas_layer_group_added.bind(this));
    },
    on_canvas_layer_group_added: function (lg) {
        if (lg.has_canvas) {
            lg.get_canvas_info = this.get_canvas_info.bind(this);
            lg.get_pixel_from_coordinate = this.get_pixel_from_coordinate.bind(this);
        }
    },
    get_canvas_info: function (in_canvas_extent) {
        var mapExtent = this.get_map_bounds();
        var canvasOrigin = this.ol_object.getPixelFromCoordinate([in_canvas_extent[0], in_canvas_extent[3]]);
        var mapOrigin = this.ol_object.getPixelFromCoordinate([mapExtent[0], mapExtent[3]]);
        var canvas_deta = [mapOrigin[0] - canvasOrigin[0], mapOrigin[1] - canvasOrigin[1]];
        return {delta: canvas_deta, canvas_origin: canvasOrigin, map_origin: mapOrigin};
    },
    get_pixel_from_coordinate: function (in_ol_point, in_canvas_pixel_delta) {
        // Calculate the canvas pixel by adding the map to canvas delta to the reference point on the map given the coordinate    
        var canvas_pixel = OCS.Viewer.Live.Utilities.array_add(this.ol_object.getPixelFromCoordinate(ol.proj.transform(in_ol_point, OCS.Viewer.Config.default_display_projection, OCS.Viewer.Config.default_projection)), in_canvas_pixel_delta);
        return {x: canvas_pixel[0], y: canvas_pixel[1]};
    }
});